export const validateCheckoutForm = (form) => {
    const isValid = form.checkValidity();
    form.classList.add('was-validated');
    return isValid;
};
